/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ExportedCredentialBase
 */
export interface ExportedCredentialBase {
    /**
     * The ID of the credential
     * @type {string}
     * @memberof ExportedCredentialBase
     */
    id: string;
    /**
     * The time when the credential was last used to authenticate successfully
     * @type {Date}
     * @memberof ExportedCredentialBase
     */
    last_used?: Date;
}

/**
 * Check if a given object implements the ExportedCredentialBase interface.
 */
export function instanceOfExportedCredentialBase(value: object): value is ExportedCredentialBase {
    if (!('id' in value) || value['id'] === undefined) return false;
    return true;
}

export function ExportedCredentialBaseFromJSON(json: any): ExportedCredentialBase {
    return ExportedCredentialBaseFromJSONTyped(json, false);
}

export function ExportedCredentialBaseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExportedCredentialBase {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'last_used': json['last_used'] == null ? undefined : (new Date(json['last_used'])),
    };
}

export function ExportedCredentialBaseToJSON(json: any): ExportedCredentialBase {
    return ExportedCredentialBaseToJSONTyped(json, false);
}

export function ExportedCredentialBaseToJSONTyped(value?: ExportedCredentialBase | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'last_used': value['last_used'] == null ? value['last_used'] : value['last_used'].toISOString(),
    };
}

